import * as types from './types';

export const refreshVariations = () => ({
  type: types.CHANGE_VARIATIONS_VERSION
});
